/**
 * ระยะสำหรับพิมพ์ CPCL — หน่วยเป็น dots ที่ 8 dots/มม. (203 dpi) คูณ 8 จากมิลลิเมตรที่วัดได้
 * ใช้เฉพาะทาง mobile printer (Relay) ทาง WebUSB ไม่มีส่วนนี้เลย
 *
 * เป็นค่า **ต่อเครื่อง ต่อล็อตป้าย** ไม่ใช่ค่าที่ยกไปใช้ต่อได้ — ต้องส่งครบทั้ง 5 ค่าเสมอ
 * ห้ามพึ่ง default ของ library (384 / 168 / 88 / 0 / 40) ซึ่งเป็นค่าเก่า ถ้าเผลอไม่ส่งจะได้ค่านั้น
 * โดยไม่มีสัญญาณเตือน
 */
export interface CpclGeometry {
  /** > 0 และหาร 8 ลงตัว — หน้ากว้างหัวพิมพ์ ไม่ใช่ความกว้างป้าย */
  readonly widthDots: number;
  /** > 0 และ >= ความสูงผืน bitmap ของป้าย */
  readonly heightDots: number;
  /** >= 0 — น้อยไปตัดซ้าย มากไปตัดขวา library ไม่เช็คให้ */
  readonly xDots: number;
  /** >= 0 และ <= bottomMarginDots */
  readonly yDots: number;
  /** >= 0 และ >= yDots — น้อยกว่า yDots คือเสีย yDots แถวท้ายของทุกป้าย */
  readonly bottomMarginDots: number;
}

/**
 * ค่าที่วัดบน Hanin/HPRT ม้วน 50 มม. — เป็นค่าเริ่มต้นของ signal ที่หน้าคาลิเบรตเขียนทับได้
 * ไม่ใช่ค่าคงที่ที่ส่งเข้า build() ตรง ๆ
 *
 * ⚠️ constraint ที่ไม่มีใครเช็คให้: `heightDots + bottomMarginDots` ต้องไม่เกินระยะพิทช์ของป้าย
 * ตอนนี้คือ 168 + 18 = 186 dots (23.25 มม.) — library ตรวจไม่ได้เพราะไม่รู้ว่าป้ายที่ใส่อยู่มีพิทช์
 * เท่าไร และ relay ก็ไม่รู้ เกินแล้วจะไม่มี error ที่ไหนเลย เนื้อหาจะร่นไปป้ายถัดไปเรื่อย ๆ ทั้งม้วน
 */
export const MEASURED_GEOMETRY: CpclGeometry = {
  widthDots: 384,
  heightDots: 168,
  xDots: 84,
  yDots: 16,
  bottomMarginDots: 18
};
